// @flow
import * as React from "react"

export function NotFoundView(props: Object) {
  return <div {...props}>404!</div>
}



// WEBPACK FOOTER //
// ./src/common/NotFoundView.js